<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
}
</script>

<template>
  <!-- start page title - Redesigned Structure -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-content">
          <h4>{{ title }}</h4>
          <b-breadcrumb v-if="items && items.length > 0" :items="items" class="page-breadcrumb"></b-breadcrumb>
        </div>

        <div class="page-title-right">
          <slot name="header-button"></slot>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
